import { NoGamesProps } from './interfaces';
import styles from './sportschedule.module.scss';
import { Text } from '@/ui-components/atoms/Text/Text';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

export default function NoGames({ logo, logoSize = 'large', title, children, classNames }: NoGamesProps) {
    return (
        <div className={`${styles.noGames} ${classNames}`}>
            {logo && logo.url && (
                <ImageWrapper
                    optimizedWidth={144}
                    optimizedHeight={144}
                    src={logo?.url || ''}
                    className={styles[logoSize]}
                    alt=""
                />
            )}
            <Text tag="div" variant="h5" className={styles.noGamesTitle}>
                {title}
            </Text>
            <div className={styles.noGamesMsg}>{children}</div>
        </div>
    );
}
